<form [formGroup]="resetForm" (ngSubmit)="forgotFormSubmit()" novalidate>
  <tc-form-group>
      <tc-input [placeholder]="'Password'" [type]="'password'" formControlName="password"></tc-input>
      <ng-container *ngFor="let error of error_messages.password">
        <tc-form-description
          [tcColor]="'#e24d4d'"
          *ngIf="resetForm.get('password').hasError(error.type) && (resetForm.get('password').dirty || resetForm.get('password').touched)">
          {{ error.message }}
      </tc-form-description>
      </ng-container>
  </tc-form-group>

  <tc-form-group>
      <tc-input [placeholder]="'Confirm Password'"  [type]="'password'" formControlName="confirmpassword"></tc-input>
      <ng-container *ngFor="let error of error_messages.confirmpassword">
        <tc-form-description
          [tcColor]="'#e24d4d'"
          *ngIf="resetForm.get('confirmpassword').hasError(error.type) && (resetForm.get('confirmpassword').dirty || resetForm.get('password').touched)">
          {{ error.message }}
        </tc-form-description>
      </ng-container>
      <tc-form-description
          [tcColor]="'#e24d4d'"
          *ngIf="mustMatch == true">
          Password doesn't match.
      </tc-form-description>
  </tc-form-group>

  <div class="actions d-flex justify-content-between">
    <button
        tc-button
        [view]="'accent'"
        [load]="resetFormLoad"
        [disabled]="resetForm.invalid"
      >
        Reset
    </button>
    <button
        tc-button
        [view]="'accent'"
        [routerLink]="['../', 'sign-in']"
      >
        Go back
    </button>
  </div>
</form>